import Ivend from 'contract/Ivend.json';
import {useContract} from "Standard/hooks/useCommonContracts";
import {getIvendContract} from "utils/getAddress";

export const useIvendContract = () => {
  const abi = Ivend.abi;
  return useContract(abi, getIvendContract());
}